import {html, LitElement, unsafeCSS} from "lit";
import {customElement, property, query} from "lit/decorators.js";
import style from "./IdsModalElement.css?inline";
import {ROOT_TAG} from "../../globals";
import {unsafeStatic} from "lit/static-html.js";
import {t} from "i18next";

const tagName = `${ROOT_TAG}-ids-modal`;
export const InterstateModal = unsafeStatic(tagName);

@customElement(tagName)
export class IdsModalElement extends LitElement {
  static styles = unsafeCSS(style);

  @property()
  onClose: () => void;

  @property()
  onConfirm: () => void;

  @query(".ids-modal")
  modal: HTMLDialogElement;

  show() {
    this.modal?.showModal();
  }

  protected firstUpdated() {
    this.modal?.addEventListener("close", () => {
      this.onClose();
    });
  }

  render() {
    return html`
      <dialog
        class="ids-modal"
        data-ids-variant="condensed"
        aria-modal="true"
        role="dialog"
        closedby="any">
        <h4 class="ids-modal-header"><slot name="header"></slot></h4>
        <div class="ids-modal-body ids-type">
          <slot name="body"></slot>
        </div>
        <div class="ids-modal-footer flex">
          <button
            id="modal-cancel-button"
            class="ids-btn"
            data-ids-size="sm"
            data-ids-variant="tertiary"
            @click=${() => {
              this.modal.close();
              this.onClose();
            }}>
            ${t("modal.cancelButton")}
          </button>
          <button
            id="modal-confirm-button"
            class="ids-btn"
            data-ids-variant="primary"
            data-ids-size="sm"
            @click=${() => {
              this.modal.close();
              this.onConfirm();
            }}>
            ${t("modal.confirmButton")}
          </button>
        </div>
      </dialog>
    `;
  }
}
